<template>
  <div class="message-popup-wrapper" v-bind="$attrs">

    <v-card style="display: flex;">
      <!-- complete button -->
      <v-btn
        v-if="message?.convo_mentions?.length > 0 && message.convo_mentions.some((m) => m.user_id === userId && !m.completed)"
        icon
        variant="text"
        style="width: 25px; height: 25px; display: inline;"
        @click="completeTask()"
      >
        <v-icon size="small">mdi-check-outline</v-icon>
        <v-tooltip activator="parent" location="top">Complete task</v-tooltip>
      </v-btn>

    </v-card>
    <div class="action-buttons" ref="popupScroll">
    <!-- reply button -->
      <v-btn icon variant="text" class="icon-btn" @click="AddRef">
        <v-icon size="small">mdi-reply</v-icon>
        <v-tooltip activator="parent" location="top">Reply</v-tooltip>
      </v-btn>
      <div v-if="!['/frontdesk', '/labCases', '/osclaims'].includes($route.path) && this.message.system_process != 'thread_internal'">
           <!--thread button -->
    <v-btn  @click="createthread()" variant="text" class="icon-btn">
      <v-icon size="small">mdi-plus</v-icon>
      <v-tooltip activator="parent" location="top">Add Thread Convo</v-tooltip>
    </v-btn>
    <!-- quick remainder button -->
    <v-btn  @click="openQuickReminder" variant="text" class="icon-btn">
      <v-icon size="small">mdi-clock-fast</v-icon>
      <v-tooltip activator="parent" location="top">Quick Reminder</v-tooltip>
    </v-btn>
      </div>
    <!-- add tag — always visible when manual tagging is enabled and not frontdesk/labCases -->
      <v-btn
        v-if="can_manual_tagging && !['/frontdesk', '/labCases'].includes($route.path) && message.system_process != 'thread_internal'"
        icon
        variant="text"
        class="icon-btn"
        @click="toggleTagPopup"
      >
        <v-icon size="small" color="red">mdi-tag-plus</v-icon>
        <v-tooltip activator="parent" location="top">
          Apply Tag
        </v-tooltip>
      </v-btn>
    <!-- references button -->
      <v-btn icon variant="text" class="icon-btn" @click="seeRef">
        <v-icon size="small">mdi-hand-pointing-down</v-icon>
        <v-tooltip activator="parent" location="top">References</v-tooltip>
      </v-btn>
    </div>

    <!-- References Dialog -->
    <v-dialog v-model="dialog" width="50%">
      <v-card>
        <v-card-title>References</v-card-title>
        <v-card-text>
          <div v-if="filteredMessage && filteredMessage.length > 0">
            <DynamicScroller :items="filteredMessage" :min-item-size="200" direction="horizontal" key-field="convo_message_id" class="horizontal-scroller"
             :buffer="2000" ref="scroller">
              <template v-slot="{ item, active }">
                <DynamicScrollerItem :item="item" :active="active" class="scroll-item">
                  <div
                    v-if="item && item.message"
                    class="ref-item"
                    @click="showRefMsg(item)"
                  >
                    <v-icon>mdi-hand-pointing-up</v-icon>
                    <span>{{ item.message }}</span>
                  </div>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
          </div>
          <div v-else>
            No References for this message
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <!-- Tag popup -->
  <div  class="shared-overlay" v-if="showTagPopup">
    <TagPopup
      v-model="showTagPopup"
      :tags="filteredTags"
      @applyTag="addTagToconvo"
      :isQuickReminder="isQuickReminder"
      :reminders="reminder"
      @applyReminder="applyQuickReminder"
      :enableEdit="!isQuickReminder"
      :isTagpopup="!isQuickReminder"
    />
  </div>
  </div>
</template>

<script>
import ConvoSerice from "@/services/convoService";
import tagService from "../../services/tagService";
import { mapGetters, mapActions, mapMutations } from "vuex";
import eventBus from "@/eventBus";
import Message from "@/components/Messenger/Message";
import TagPopup from "../CustomPopup.vue";
import { ALERT } from "../../constants/alert";
import { DateFormats } from '../../constants/formats';
export default {
  inheritAttrs: false,
  name: "MessagePopup",
  props: {
    message: { type: Object, default: null },
  },
  components: {
     Message, 
     TagPopup,
    },
  emits: ["showRefMsg", "showRef"],
  data() {
    return {
      dialog: false,
      filteredMessage: null,
      showTagPopup: false,
      systemTags :["Open", "Archive", "Close"],
      isQuickReminder : false,
         reminder : [
      { 
          reminder_id: 0,
          reminder_title: "1 hour Later",
          duration: 1,
          unit: "hour",
      },
      {
        reminder_id: 1,
        reminder_title: "Later 4 PM",
        fixedTime: "16:00",
        icon : "mdi-weather-sunset",
        color:'#FF4500'
    },
    {
        reminder_id: 2,
        reminder_title: "Later Tomorrow 8 AM",
        fixedTime: "08:00",
        isTomorrow: true,
        icon : "mdi-weather-sunny",
        color:'#FFD700'
    }
  ],
    };
  },
  computed: {
    ...mapGetters(["userId"]),
    ...mapGetters("convos",["getCurrent_process"]),
    ...mapGetters("window", ["isMobile"]),
    ...mapGetters("tags", ["tagsHashnew", "convoTags", "osclaimsTags", "allTags", "tagsHash", "can_manual_tagging"]),
    ...mapGetters("threadconvo", ["getcreatethreaddata"]),
    filteredTags() {
      const selectedTagIds = this.message.convo_tags.map((ct) => ct.tag.tag_id);
      if (this.$route.path === '/osclaims') {
        return this.osclaimsTags.filter(tag => !selectedTagIds.includes(tag.tag_id));
      }
      if (this.$route.path === '/conversation') {
        return this.convoTags.filter(
          tag =>
            (tag.tag_Process === this.message.convo.system_process || tag.tag_Process === 'All') &&
            !selectedTagIds.includes(tag.tag_id)
        );
      }
      return this.allTags.filter(
        (tag) =>
          (tag.tag_Process === this.message.convo.system_process || tag.tag_Process === 'All') &&
          !selectedTagIds.includes(tag.tag_id)
      );
    },
  },
  watch: {
    filteredMessage(newval){
      this.filteredMessage = newval;
    }
  },
  methods: {
    ...mapMutations("threadconvo",["PARENTTHREADDATA","SHOWCONVORIGHTPANEL"]),
    ...mapMutations("convos", ["changeReferencedConvo"]),
    ...mapActions("convos", ["getMessages","getInternalMessages"]),
    ...mapActions("threadconvo", ["createConvo"]),
    async seeRef() {
      this.$emit('showRef',true);
      eventBus.$emit("hidepopup");
      this.dialog = true;
      const msgs = this.getCurrent_process === 'internal'? await this.getInternalMessages(this.message.convo_id): await this.getMessages(this.message.convo_id);
      this.filteredMessage = msgs.filter(msg => msg.ref === this.message.convo_message_id);
    },
    closeDialog(){
      this.$emit('showRef',false);
      this.dialog = false;
    },
    AddRef() {
      this.changeReferencedConvo({
        convo_message_id: this.message.convo_message_id,
        message: this.message.message,
        media_id: this.message.convo_attachments?.[0]?.media_id ?? null
      });
      eventBus.$emit("hidepopup");
      eventBus.$emit("referenced");
    },
    showRefMsg(item) {
      this.$emit('showRefMsg', item);
  
    },
    completeTask() {
      ConvoSerice.updateMentionStatus(this.message.convo_id, this.message.convo_message_id, { completed: true }).catch(
        (e) => {
          eventBus.$emit("alert", "Error completing task");
          console.log(e);
        }
      );
    },
    toggleTagPopup() {
      if (this.isMobile) {
        setTimeout(() => {
          this.showTagPopup = !this.showTagPopup;
        }, 200);
      } else {
        this.showTagPopup = !this.showTagPopup;
      }
        },

    async addTagToconvo(tag_id) {
      try {
        const addConvoTag = {
          convo_message_id: this.message.convo_message_id,
          tag_id: tag_id,
          convo_id: this.message.convo_id,
        };

        const specialTagId =this.message.convo_tags.map(t => ({
          tag_id: t.tag.tag_id,
          tag_name: this.tagsHashnew[t.tag.tag_id]?.tag_name
        })).find(t => this.systemTags.includes(t.tag_name))?.tag_id || null
        console.log("remove TagId:", specialTagId);

        const addingIsSystemTag = this.systemTags.includes(
          this.tagsHashnew[tag_id]?.tag_name
        );
        if (specialTagId && addingIsSystemTag) {
      let deletePayload = {
        tagId: specialTagId,
        messageId: this.message.convo_message_id,
        convo_id: this.message.convo_id,
      };

      let removeResponse = await tagService.removeConvoTag(deletePayload);

      if (removeResponse.status === 200) {
        this.message.convo_tags = this.message.convo_tags.filter(
          (t) => t.tag.tag_id !== specialTagId
        );
        console.log("Removed old system tag:", specialTagId);
      }
    }   
        const res = await tagService.addConvoTag(addConvoTag);

        if (res.status === 201 || res.status === 200) {
          // Find the tag from allTags
          const selectedTag = this.allTags.find(tag => tag.tag_id === tag_id);
          if (!selectedTag) return;

          const newTag = { 
            convo_message_id: this.message.convo_message_id, 
            tag: { 
              tag_id: selectedTag.tag_id
            }
          };
          this.message.convo_tags.push(newTag);
          eventBus.$emit("hidepopup");
          eventBus.$emit("alert", {
            message: "Tag Added Successfully",
            type: ALERT.SUCCESS,
          });
        }
      } catch (error) {
        eventBus.$emit("alert", {
          message: "Failed To Add Tag",
          type: ALERT.ERROR,
        });
      }
    },
    async addtagtoUI(convo_message_id,tag_id){
      try {
        const newTag = {
          convo_message_id: convo_message_id,
          tag: { tag_id: tag_id }
        };
        this.message.convo_tags.push(newTag);
        eventBus.$emit("hidepopup");
        eventBus.$emit("alert", {
          message: "Tag Added Successfully",
          type: ALERT.SUCCESS,
        });
      } catch (error) {
        eventBus.$emit("alert", {
          message: "Failed To Add Tag",
          type: ALERT.ERROR,
        });
      }
    },
openQuickReminder() {
  this.isQuickReminder = true;
  this.showTagPopup = true;

  // FIXED — store correct parent fields
  let data = {
    parent_convo_id: this.message.convo_id,
    parent_message_id: this.message.convo_message_id,
    message: this.message
  };

  this.PARENTTHREADDATA(data);
},
    createthread(){
      eventBus.$emit("hidepopup");
    
          let data = {
            parent_convo_id: this.message.convo_id,
            parent_message_id: this.message.convo_message_id,
            message:{ ...this.message },
          };
      if (this.message?.convo_attachments?.length > 0) {
        data["convo_attachments"] = this.message.convo_attachments[0];
      }

     this.PARENTTHREADDATA(data);
       this.$nextTick(() => {
    this.SHOWCONVORIGHTPANEL(true);
    eventBus.$emit("createthreadConvo");
  });
    },
async applyQuickReminder(reminder) {
  this.showCustomPopup = false;
  this.isQuickReminder = false;

  let reminderTime;
  if (reminder.fixedTime) {
    if (reminder.isTomorrow) {
      reminderTime = this.dayjs().add(1, "day").set({ hour: 8, minute: 0 });
    } else {
      reminderTime = this.dayjs().set({ hour: 16, minute: 0 });
      if (this.dayjs().isSameOrAfter(reminderTime)) {
        reminderTime = this.dayjs().add(1, "day").set({ hour: 16, minute: 0 });
      }
    }
  } else {
    reminderTime = this.dayjs().add(reminder.duration, reminder.unit);
  }

  let formattedDate = reminderTime.format(DateFormats.DATE_TIME_FORMAT_24H);

  try {

    // FIXED — now Vuex contains correct parent info
const createData = {
  message: reminder.reminder_title,
  parent_convo_id: this.getcreatethreaddata?.parent_convo_id,
  parent_message_id: this.getcreatethreaddata?.parent_message_id,
  type: "thread",
};


    const createdMessage = await this.createConvo(createData);

    if (createdMessage?.convo_id) {
      const payload = {
        date: formattedDate,
        convo_id: createdMessage.convo_id
      };

      const res2 = await ConvoSerice.addInternalReminder(payload);
console.log(res2,"testing Full reminder",payload)
      if (res2.status === 200) {
        eventBus.$emit("alert", {
          message: "Reminder Added Successfully",
          type: ALERT.SUCCESS,
        });
      }
    }

  } catch (error) {
    console.log(error);
    eventBus.$emit("alert", {
      message: "Failed To Add Reminder",
      type: ALERT.ERROR,
    });
  }
},
    onScroll(event) {
      const el = this.$refs.popupScroll;
      if (!el) return;

      const deltaY = event.deltaY ?? 0;
      el.scrollLeft += deltaY;

      const isMouseWheel = Math.abs(deltaY) > 50 || event.deltaMode === 1;
      if (isMouseWheel) event.preventDefault();
    }
  },
  mounted() {
    const el = this.$refs.popupScroll;
    if (el) el.addEventListener("wheel", this.onScroll, { passive: false });
    eventBus.$on("UI_add_Tag", data =>
      setTimeout(() => this.addtagtoUI(data.convo_message_id, data.tag_id), 1000)
    );
  },
  beforeUnmount() {
    const el = this.$refs.popupScroll;
    if (el) el.removeEventListener("wheel", this.onScroll);
    eventBus.$off("UI_add_Tag");
  }
};
</script>
<style scoped>
.message-popup-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
  overflow: visible;
  background-color: white;
  position: relative;
}

/* HORIZONTAL STRIP SCROLL FIX */
.action-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100%;
  padding: 2px;
  scroll-behavior: smooth;

  /* hide scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.action-buttons::-webkit-scrollbar { display: none; }

.icon-btn {
  width: 28px;
  height: 28px;
  min-width: 28px !important;
  flex-shrink: 0;
}

.v-card {
  flex: 0 0 auto;
  align-items: center;
  flex-wrap: nowrap;
}

.horizontal-scroller {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  height: 120px;
}

.scroll-item {
  display: inline-flex;
  flex: 0 0 auto;
  margin-right: 10px;
  align-items: center;
}

.ref-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  white-space: normal;
  width: 200px;
}
.shared-overlay {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 10;
  transform: none;
  width: auto;
  height: auto;
  max-width: 90vw;
}

</style>
